module.exports = __webpack_public_path__ + "static/media/appStore.8a889df7.png";